import Image from "@/components/Image";
import { getImageSrc2x } from "@/utils/imageUrl";
import { useEffect, useRef } from "react";
import styles from "./card.module.less";
export default function Video({ style, src, isHovering, coverFile }) {
  const videoRef = useRef(null);
  useEffect(() => {
    if (isHovering) {
      videoRef?.current?.play();
    } else {
      videoRef?.current?.pause();
    }
  }, [isHovering]);

  return (
    <>
      {isHovering && (
        <video
          className={styles.video}
          src={src}
          muted
          loop
          style={style}
          preload="metadata"
          ref={videoRef}
          width={240}
        />
      )}
      <Image
        width={240}
        style={style}
        {...getImageSrc2x(coverFile, { width: 240 })}
        alt="封面"
      />
      {!isHovering && (
        <Image
          width={58}
          className={styles.playIcon}
          alt={"播放按钮"}
          src="https://cdn.dancf.com/fe-assets/20230822/9d22550a930810d43f08f00a78816606.png"
        />
      )}
    </>
  );
}
